// src/components/ProductRatingBadge.js
// Compact star rating + review count badge for product cards in grid/listing
// views (Home.js Featured Products, OurScents.js, ProductDetail.js related
// products). Looks itself up from the shared, once-per-page-load ratings
// cache (useProductRatings), so dropping this into many cards costs one
// shared fetch, not one per card. Renders nothing if the product has no
// reviews yet.

import React from 'react';
import StarRating from './StarRating';
import { useProductRatings } from '../hooks/useProductRatings';

const ProductRatingBadge = ({ productId, productTitle }) => {
    const { getRating } = useProductRatings();
    const stats = getRating(productTitle);

    if (!stats || typeof stats.average !== 'number' || !Number.isFinite(stats.average) || !stats.count) {
        return null;
    }

    return (
        <div className="flex items-center gap-1.5 mb-2" data-product-id={productId}>
            <StarRating rating={Math.round(stats.average)} size={13} />
            <span className="text-muted-foreground text-xs">
                {stats.average.toFixed(1)} ({stats.count})
            </span>
        </div>
    );
};

export default ProductRatingBadge;
